import {THEME} from '@wandb/weave/common/css/color.styles';
import {Link} from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 50px;
  margin-bottom: 30px;
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const Separator = styled.hr`
  width: 90%;
  height: 2px;
  background-color: light-dark(#4a5568, var(--moon-500));
  border: none;
  margin: 0 auto;
`;

export const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${THEME.textPrimary};
  min-width: 180px;
  flex-shrink: 0;
`;

export const PillsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const PillLink = styled(Link)<{
  $active?: boolean;
  $backgroundColor?: string;
  $textColor?: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 24px;
  border-radius: 24px;
  font-family: 'Source Sans 3', Sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.12em;
  letter-spacing: 0.0625em;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  ${p => {
    if (p.$active) {
      const bgColor =
        p.$backgroundColor || 'light-dark(#2b3038, var(--moon-100))';
      const txtColor = p.$textColor || 'light-dark(#ffffff, var(--moon-900))';
      return `
        background-color: ${bgColor};
        color: ${txtColor};
        border-color: light-dark(#2b3038, var(--moon-100));
      `;
    }

    if (p.$backgroundColor) {
      return `
        background-color: ${p.$backgroundColor};
        color: ${p.$textColor || '#ffffff'};
        border-color: ${p.$backgroundColor};

        &:hover {
          filter: brightness(0.9);
          color: ${p.$textColor || '#ffffff'};
          text-decoration: none;
        }
      `;
    }

    return `
      background-color: light-dark(#79808a, var(--moon-500));
      color: light-dark(#ffffff, var(--moon-900));
      border-color: light-dark(#79808a, var(--moon-500));

      &:hover {
        background-color: light-dark(#2b3038, var(--moon-100));
        border-color: light-dark(#2b3038, var(--moon-100));
        color: light-dark(#ffffff, var(--moon-900));
        text-decoration: none;
      }
    `;
  }}
`;

export const PillButton = styled.button<{
  $active?: boolean;
  $backgroundColor?: string;
  $textColor?: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 24px;
  border-radius: 24px;
  font-family: 'Source Sans 3', Sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.12em;
  letter-spacing: 0.0625em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  ${p => {
    if (p.$active) {
      const bgColor =
        p.$backgroundColor || 'light-dark(#2b3038, var(--moon-100))';
      const txtColor = p.$textColor || 'light-dark(#ffffff, var(--moon-900))';
      return `
        background-color: ${bgColor};
        color: ${txtColor};
        border-color: light-dark(#2b3038, var(--moon-100));
      `;
    }

    if (p.$backgroundColor) {
      return `
        background-color: ${p.$backgroundColor};
        color: ${p.$textColor || '#ffffff'};
        border-color: ${p.$backgroundColor};

        &:hover {
          filter: brightness(0.9);
          color: ${p.$textColor || '#ffffff'};
        }
      `;
    }

    return `
      background-color: light-dark(#79808a, var(--moon-500));
      color: light-dark(#ffffff, var(--moon-900));
      border-color: light-dark(#79808a, var(--moon-500));

      &:hover {
        background-color: light-dark(#2b3038, var(--moon-100));
        border-color: light-dark(#2b3038, var(--moon-100));
        color: light-dark(#ffffff, var(--moon-900));
      }
    `;
  }}
`;

export const ExternalPillLink = styled.a<{
  $backgroundColor?: string;
  $textColor?: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 7px 24px;
  border-radius: 24px;
  font-family: 'Source Sans 3', Sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.12em;
  letter-spacing: 0.0625em;
  text-decoration: none;
  text-transform: uppercase;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  ${p => {
    if (p.$backgroundColor) {
      return `
        background-color: ${p.$backgroundColor};
        color: ${p.$textColor || '#ffffff'};
        border-color: ${p.$backgroundColor};

        &:hover {
          filter: brightness(0.9);
          color: ${p.$textColor || '#ffffff'};
          text-decoration: none;
        }
      `;
    }

    return `
      background-color: light-dark(#79808a, var(--moon-500));
      color: light-dark(#ffffff, var(--moon-900));
      border-color: light-dark(#79808a, var(--moon-500));

      &:hover {
        background-color: light-dark(#2b3038, var(--moon-100));
        border-color: light-dark(#2b3038, var(--moon-100));
        color: light-dark(#ffffff, var(--moon-900));
        text-decoration: none;
      }
    `;
  }}
`;
